/**
 * Logout Modal
 *
 * Displays a modal asking the user if they are sure they want to logout. If the user 
 * clicks "yes, logout", the component logs the user out and navigates to the login page. 
 * The component is wrapped in an AppContext.Consumer that provides a function to 
 * close the navigation menu when the user logs out.
 */

import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { navigate } from '../utils/navigate'
import { logout } from '../utils/auth'
import AppContext from '../utils/context'

class Logout extends React.Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      modalShow: false,
    }
  }

  handleSubmit(event, setNavOpen) {
    event.preventDefault()
    setNavOpen(false)
    logout(() => navigate(`/login`))
  }

  render() {
    let modalClose = () => this.setState({ modalShow: false })

    return (
      <AppContext.Consumer>
        {({ setNavOpen }) => (
          <>
            <button className={`btn btn-link px-0 py-0`} onClick={() => this.setState({ modalShow: true })}>
              Logout
            </button>

            <Modal show={this.state.modalShow} onHide={modalClose} centered aria-labelledby="logout-modal-title">
              <Modal.Header closeButton>
                <Modal.Title id="logout-modal-title">Logout</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Any previous save data will be lost. Are you sure you want to logout?</p>
                <form
                  className={`form-group`}
                  method="post"
                  onSubmit={event => {
                    this.handleSubmit(event, setNavOpen)
                  }}>
                  <input className={`btn btn-block btn-success text-uppercase`} type="submit" value=" yes, logout" />
                </form>
                <button className={`btn btn-block btn-tiny mt-4`} onClick={modalClose}>
                  Cancel
                </button>
              </Modal.Body>
            </Modal>
          </>
        )}
      </AppContext.Consumer>
    )
  }
}
export default Logout
